import React from 'react';
import Form from 'react-bootstrap/Form';
import { LinkButton } from 'common';
import '../../styles/commonPage.scss';

const ForgotCredentialsPage = () => {
  return (
    <div className="occu-form">
      <h5>Tell us how we can help you</h5>
      <Form>
        <LinkButton href="/olb/forgot-username">Find My Username</LinkButton>
        <LinkButton href="/olb/forgot-password">Reset My Password</LinkButton>
      </Form>
    </div>
  );
};

export default ForgotCredentialsPage;
